export const maxDisplayWidth: number = 500;
export const designWidth: number = 360;
export const unitPrecision: number = 5;
const warning = {
  blue: {
    fontColor: "#005cfd",
    fillColor: "#005cfd",
  },
  yellow: {
    fontColor: "#ead14c",
    fillColor: "#ffeb81",
  },
  orange: {
    fontColor: "#FFAA46",
    fillColor: "#F3B770",
  },
  red: {
    fontColor: "#FF534E",
    fillColor: " #FF9491",
  },
};
export const appThemeStyle: any = {
  cloudy: {
    headerStyle: {
      backgroundColor: "rgba(255, 255, 255, 0.5)",
      boxShadow: "0px 3px 7px 1px rgba(13, 130, 212, 0.37)",
      backdropFilter: "blur(28px)",
    },
    mainItemStyle: {
      backgroundColor: "rgba(0, 103, 180, 0.4)",
      boxShadow: "0px 2px 8px 2px rgba(13, 130, 212, 0.29)",
      backdropFilter: "blur(5px)",
    },
    tipsStyle: {
      backgroundColor: "rgba(142, 208, 248, 0.2)",
    },
    warning: warning,
  },
  thunder: {
    headerStyle: {
      backgroundColor: "rgba(255, 255, 255, 0.5)",
      boxShadow: "0px 3px 7px 1px rgba(11, 2, 58, 0.37)",
      backdropFilter: "blur(28px)",
    },
    mainItemStyle: {
      backgroundColor: "rgba(231, 231, 231, 0.1)",
      boxShadow: "0px 2px 8px 2px rgba(11, 2, 58, 0.29)",
      backdropFilter: "blur(5px)",
    },
    tipsStyle: {
      backgroundColor: "rgba(138, 116, 252, 0.2)",
    },
    warning: warning,
  },
  rain: {
    headerStyle: {
      backgroundColor: "rgba(255, 255, 255, 0.5)",
      boxShadow: "0px 3px 7px 1px rgba(11, 2, 58, 0.37)",
      backdropFilter: "blur(28px)",
    },
    mainItemStyle: {
      backgroundColor: "rgba(40, 40, 40, 0.2)",
      boxShadow: "0px 3px 4px 1px rgba(111, 111, 111, 0.5)",
      backdropFilter: "blur(3px)",
    },
    tipsStyle: {
      backgroundColor: "rgba(196, 196, 196, 0.2)",
    },
    warning: warning,
  },
  sunshine: {
    headerStyle: {
      backgroundColor: "rgba(255, 255, 255, 0.5)",
      boxShadow: "0px 3px 7px 1px rgba(13, 130, 212, 0.37)",
      backdropFilter: "blur(28px)",
    },
    mainItemStyle: {
      backgroundColor: "rgba(23, 150, 244, 0.4)",
      boxShadow: "0px 2px 8px 2px rgba(13, 130, 212, 0.29)",
      backdropFilter: "blur(2px)",
    },
    tipsStyle: {
      backgroundColor: "rgba(139,190,235,0.2)",
    },
    warning: warning,
  },
  snow: {
    headerStyle: {
      backgroundColor: "rgba(255,255,255,0.5)",
      boxShadow: "0px 3px 7px 1px rgba(13, 130, 212, 0.37)",
      backdropFilter: "blur(28px)",
    },
    mainItemStyle: {
      backgroundColor: "rgba(0,102,178,0.4)",
      boxShadow: "0px 2px 8px 2px rgba(13, 130, 212, 0.29)",
      backdropFilter: "blur(5px)",
    },
    tipsStyle: {
      backgroundColor: "rgba(41,184,248,0.2)",
    },
    warning: warning,
  },
  rain_snow: {
    headerStyle: {
      backgroundColor: "rgba(255,255,255,0.5)",
      boxShadow: "0px 3px 7px 1px #4A6D80",
      backdropFilter: "blur(28px)",
    },
    mainItemStyle: {
      backgroundColor: "rgba(17,81,116,0.4)",
      boxShadow: "0px 2px 8px 2px #41728B",
      backdropFilter: "blur(2px)",
    },
    tipsStyle: {
      backgroundColor: "rgba(90,153,185,0.2)",
    },
    warning: warning,
  },
  night: {
    headerStyle: {
      backgroundColor: "rgba(255,255,255,0.5)",
      boxShadow: "0px 2px 8px 2px #0D1F44",
      backdropFilter: "blur(28px)",
    },
    mainItemStyle: {
      backgroundColor: "rgba(20,47,112,0.4)",
      boxShadow: "0px 2px 8px 2px #0D1F44",
      backdropFilter: "blur(2px)",
    },
    tipsStyle: {
      backgroundColor: "rgba(62,93,160,0.2)",
    },
    warning: warning,
  },
};

export const limit3min = 1000 * 60 * 3;
export const limit5min = 1000 * 60 * 5;
